import { EducationalContentIcon, ExerciseIcon, QuestionaryIcon } from "components/icons"
import { EventTypes } from "types"

export const unitChapterElementTypeList = [
    { id: EventTypes.Exercise, title: "exercise" },
    { id: EventTypes.Questionnaire, title: "questionnaire" },
    { id: EventTypes.EducationalContent, title: "educational_content" }
]
